import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    targets: [],
    negativeTargets: [],
    mode: "creation",
    inputToDiscover: "",
    loadingResult: true,
    lowscore: false,
    visibleRecommendedInsightsModal: {
        data: null,
        visible: false
    },
    resultMode: "dashboard",
    personasParams: null,
    personasData: null,
    personasImage: null,
    loadingPersonasData: false,
    loadingPersonasImage: false
};
const minified = createSlice({
    name: "minified",
    initialState: { ...initialState },
    reducers: {
        setTargets: (state, action) => {
            state.targets = action.payload;
        },
        setNegativeTargets: (state, action) => {
            state.negativeTargets = action.payload;
        },
        setLowscore: (state, action) => {
            state.lowscore = action.payload;
        },
        setInputToDiscover: (state, action) => {
            state.inputToDiscover = action.payload;
        },
        setLoadingResult: (state, action) => {
            state.loadingResult = action.payload;
        },
        setMode: (state, action) => {
            state.mode = action.payload;
        },
        setResultMode: (state, action) => {
            state.resultMode = action.payload;
        },
        setPersonasParams: (state, action) => {
            state.personasParams = action.payload;
        },
        setPersonasData: (state, action) => {
            state.personasData = action.payload;
        },
        setPersonasImage: (state, action) => {
            state.personasImage = action.payload;
        },
        setVisibleRecomInsights: (state, action) => {
            state.visibleRecommendedInsightsModal = action.payload;
        },
        setLoadingPersonasData: (state, action) => {
            state.loadingPersonasData = action.payload;
        },
        setLoadingPersonasImage: (state, action) => {
            state.loadingPersonasImage = action.payload;
        },
        resetState: (state, action) => {
            const newState = {...initialState};
            Object.keys(newState).forEach((key) => {
                state[key] = newState[key];
            });
        }
    }
});

const { reducer, actions } = minified;
export const {
    setTargets,
    setNegativeTargets,
    setMode,
    setResultMode,
    setLoadingResult,
    setVisibleRecomInsights,
    setPersonasParams,
    setPersonasData,
    setPersonasImage,
    setLowscore,
    setInputToDiscover,
    setLoadingPersonasData,
    setLoadingPersonasImage,
    resetState
} = actions;
export default reducer;
